export default __webpack_public_path__ + "static/chumchumpink-69e0d746be527031591c032c14571800.png";